var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHistoryDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.35C0 3.88517 -8.34465e-08 2.15276 1.02513 1.07639C2.05025 -8.76188e-08 3.70017 0 7 0C10.2998 0 11.9498 -8.76188e-08 12.9748 1.07639C14 2.15276 14 3.88517 14 7.35C14 10.8148 14 12.5473 12.9748 13.6236C11.9498 14.7 10.2998 14.7 7 14.7C3.70017 14.7 2.05025 14.7 1.02513 13.6236C-8.34465e-08 12.5473 0 10.8148 0 7.35ZM7 3.12375C7.28994 3.12375 7.525 3.37056 7.525 3.675V7.48913L8.72879 6.22523C8.93382 6.00995 9.26618 6.00995 9.47121 6.22523C9.67624 6.44051 9.67624 6.78949 9.47121 7.00477L7.37121 9.20977C7.27279 9.31318 7.13923 9.37125 7 9.37125C6.86077 9.37125 6.72721 9.31318 6.62879 9.20977L4.52877 7.00477C4.32375 6.78949 4.32375 6.44051 4.52877 6.22523C4.73379 6.00995 5.06621 6.00995 5.27123 6.22523L6.475 7.48913V3.675C6.475 3.37056 6.71006 3.12375 7 3.12375ZM4.2 10.4737C3.91005 10.4737 3.675 10.7206 3.675 11.025C3.675 11.3294 3.91005 11.5762 4.2 11.5762H9.8C10.0899 11.5762 10.325 11.3294 10.325 11.025C10.325 10.7206 10.0899 10.4737 9.8 10.4737H4.2Z",
    fill: "#FF6B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHistoryDownloadIcon);
export default __webpack_public_path__ + "static/media/payment-history-download-icon.5012529921257f25e4bf2370c11b72fd.svg";
export { ForwardRef as ReactComponent };